import {COLORS} from 'frontend/utils/color_palettes';

import {DefaultMapMarker, IconSize} from './default';

const CAPACITOR_COLOR = COLORS.NewPrimary.get(40);

/**
 * Marker represents capacitor bank on a map.
 */
export class CapacitorMapMarker extends DefaultMapMarker {
  protected override getDefaultIcon(size: IconSize, opacity = 1): string {
    return capacitorSVG(size, opacity);
  }

  protected override getRaisedIcon(size: IconSize, opacity = 1): string | null {
    return capacitorRaisedSVG(size, opacity);
  }
}

function capacitorSVG(size: number, opacity = 1, color = CAPACITOR_COLOR): string {
  return `
<svg width="${size}" height="${size}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 24C5.37262 24 3.80021e-05 18.6274 3.8147e-05 12C3.82918e-05 5.37258 5.37262 -1.44847e-07 12 0C18.6275 1.44847e-07 24 5.37258 24 12C24 18.6274 18.6275 24 12 24Z" fill="white"/>
  <rect x="2" y="2" width="20" height="20" rx="10" fill="${color}" opacity="${opacity}"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99972 9.05888L19.1174 9.05888L19.1174 10.2354L4.99972 10.2354L4.99972 9.05888Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2354 10.2353L13.2354 22L10.8825 22L10.8825 10.2353L13.2354 10.2353Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7649 2C16.7649 4.59899 14.658 6.70588 12.059 6.70588C9.46006 6.70588 7.35316 4.59899 7.35316 2H6.17669C6.17669 5.24873 8.81031 7.88235 12.059 7.88235C15.3078 7.88235 17.9414 5.24873 17.9414 2H16.7649Z" fill="white"/>
</svg>`;
}

function capacitorRaisedSVG(size: number, opacity = 1, color = CAPACITOR_COLOR): string {
  return `
<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 32C7.16345 32 3.27188e-06 24.8366 3.46501e-06 16C3.65814e-06 7.16344 7.16345 -5.4282e-07 16 -3.49691e-07C24.8366 -1.56562e-07 32 7.16344 32 16C32 24.8366 24.8366 32 16 32Z" fill="white"/>
  <rect x="4" y="4" width="24" height="24" rx="12" fill="${color}" opacity="${opacity}"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00035 12.4706L24.9415 12.4706L24.9415 13.8823L8.00035 13.8823L8.00035 12.4706Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8838 13.8824L17.8838 28L15.0603 28L15.0603 13.8824L17.8838 13.8824Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1189 4C22.1189 7.11878 19.5906 9.64706 16.4718 9.64706C13.3531 9.64706 10.8248 7.11878 10.8248 4H9.41302C9.41302 7.89848 12.5734 11.0588 16.4718 11.0588C20.3703 11.0588 23.5307 7.89848 23.5307 4H22.1189Z" fill="white"/>
</svg>`;
}
